module.exports = "https://sf6-scmcdn2-tos.pstatp.com/motor/pc/_next/static/images/2-9403b135e2026f9e2f170a86ba247192.png";